import React from "react";

const WeatherComponent = () => {
  return <div className=" flex "></div>;
};

export default WeatherComponent;
